/**
 * Компонент FloatingParticles
 * Анимированный фон с частицами в стиле 21st.dev
 * Автор: AI Market Hub
 */

import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

export default function FloatingParticles({
  count = 30,
  speed = 0.5,
  colors = ['#a855f7', '#ec4899', '#3b82f6'],
  size = { min: 2, max: 6 },
  className = '',
}) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Генерируем частицы
    const newParticles = Array.from({ length: count }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * (size.max - size.min) + size.min,
      color: colors[Math.floor(Math.random() * colors.length)],
      duration: 15 + Math.random() * 10, // 15-25 секунд
      delay: Math.random() * 5,
    }));

    setParticles(newParticles);
  }, [count, colors, size]);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {particles.map(particle => (
        <motion.div
          key={particle.id}
          className="absolute rounded-full opacity-20 blur-sm"
          style={{
            left: `${particle.x}%`,
            top: `${particle.y}%`,
            width: particle.size,
            height: particle.size,
            backgroundColor: particle.color,
          }}
          animate={{
            y: [0, -100, 0],
            x: [0, Math.random() * 50 - 25, 0],
            scale: [1, 1.2, 1],
            opacity: [0.2, 0.4, 0.2],
          }}
          transition={{
            duration: particle.duration,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: particle.delay,
          }}
        />
      ))}
    </div>
  );
}




